import DoneIcon from '@mui/icons-material/Done';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Box, Button, IconButton, InputAdornment, Modal, TextField } from "@mui/material";
import { useState } from 'react';


const style = {
	position: 'absolute' as 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 350,
	height: 450,
	bgcolor: 'background.paper',
	border: '2px solid #FF0000',
	boxShadow: 24,
	pt: 2,
	px: 4,
	pb: 3,

};

interface MatricolaPinInterface {
	onSubmit: (matricola: string, pin: string) => void
	widthMax: string
}

export default function MatricolaPinModal(props: MatricolaPinInterface) {
	const [pin, setPin] = useState("");
	const [matricola, setMatricola] = useState("");
	const [errorType, setErrorType] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const [open, setOpen] = useState(true);

	const handleClose = (event: any, reason: any) => {
		if (reason && (reason === "backdropClick" || reason === "escapeKeyDown")) {
			setOpen(true);
		} else {
			setOpen(false);
		}
	}

	const submit = () => {
		if (!matricola || !pin) {
			setErrorType("matricola");
		} else if (pin.length < 4) {
			setErrorType("pin");
		} else {
			props.onSubmit(matricola, pin);
			setOpen(false);
		}
	};


	const handleClickShowPassword = () => setShowPassword((show) => !show);

	return (
		<div>
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="parent-modal-title"
				aria-describedby="parent-modal-description"
			>
				<Box sx={{ ...style, display: "flex", alignItems: "center", flexDirection: "column" }}>
					<h2 id="parent-modal-title">Inserisci i dati</h2>
					<p id="parent-modal-description">
						Inserisci i dati per la connesione.
					</p>
					{errorType === "matricola" && <p style={{ color: 'red', marginTop: "0px", fontSize: "14px" }}>Matricola o pin mancante</p>}
					{errorType === "pin" && <p style={{ color: 'red', marginTop: "0px", fontSize: "14px" }}>Il pin deve essere di almeno 4 caratteri</p>}
					<TextField
						sx={{ width: props.widthMax }}
						id="text-field-pin"
						required
						label="Matricola"
						variant='outlined'
						color="error"
						value={matricola}
						onChange={(e) => setMatricola(e.target.value)}
					/>
					<TextField
						sx={{ marginTop: "20px", maxWidth: "247px" }}
						required
						id="text-field-matricola"
						label="Pin"
						variant='outlined'
						color='error'
						type={showPassword ? "text" : "password"}
						InputProps={{
							endAdornment: (
								<InputAdornment position='end'>
									<IconButton
										onClick={handleClickShowPassword}
										edge="end"
									>
										{showPassword ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								</InputAdornment>
							)
						}}
						value={pin}
						onChange={(e) => {
							setPin(e.target.value);
							setErrorType("");
						}}
					/>

					<Button
						sx={{ marginTop: "30px" }}
						variant='contained'
						color='error'
						onClick={() => submit()}
						endIcon={<DoneIcon />}>
						Conferma
					</Button>
				</Box>
			</Modal>
		</div>
	);
}
